import Utils from "../../utils/Utils";

export default {

    init() {

        const DEBOUNCE_MILLIS = 1500;
        const DATA_PRODUCT_ID = "product-id";
        const DATA_TRANSPORT_DOCUMENT_ITEM_ID = "transport-document-item-id";
        const DATA_INVOICE_ID = "invoice-id";

        let _transport_document = null;

        /**
         * Il documento di trasporto è stato caricato
         * @param transport_document
         */
        function transportDocumentLoaded(transport_document) {
            _transport_document = transport_document;


            $(TSF_BTN_FILTER_SUBMIT).attr('disabled', false);

            //loadSelectableProducts(_transport_document.id);
            loadAssociatedProducts(_transport_document.id);
            loadInvoices(_transport_document.id);
        }

        function loadTransportDocument(transport_document_id) {

            httpRequest.get(`admin/content/api/transport-documents/${transport_document_id}`)
                .then(response => transportDocumentLoaded(response.data.data))
                .catch(error => {
                });
        }

        loadTransportDocument(TRANSPORT_DOCUMENT_ID);

        const TABLE_DETAILS = "#table-details";
        const TABLE_DETAILS_BODY = "#table-details tbody";

        const BTN_DELETE_TRANSPORT_DOCUMENT_ITEM = ".btn-delete-transport-document-item";
        const BTN_GENERATE_INVOICE = "#btn-generate-invoice";

        const INPUT_DISCOUNT = ".input-discount";
        const INPUT_AMOUNT = ".input-amount";

        const TABLE_SELECT = "#table-select";
        const TABLE_SELECT_BODY = "#table-select tbody"

        const INPUT_PRICE = ".input-price";
        const BTN_ASSOCIATE = ".btn-associate";

        const TSF_INPUT_FILTER_PURCHASING_CHANNEL_TYPE = "#tsf-input-purchasing-channel-type";
        const TSF_INPUT_FILTER_PRODUCT_TYPE = "#tsf-input-product-type";
        const TSF_INPUT_FILTER_PRODUCT_CODE = "#tsf-input-product-code";
        const TSF_INPUT_FILTER_PROTOCOL_NUMBER = "#tsf-input-protocol-number";
        const TSF_INPUT_FILTER_PURCHASING_CHANNEL_ID = "#tsf-input-purchasing-channel-id";
        const TSF_INPUT_FILTER_SALES_CHANNEL_ID = "#tsf-input-sales-channel-id";
        const TSF_INPUT_FILTER_ORDER_EXTERNAL = "#tsf-input-order-external";
        const TSF_INPUT_FILTER_DESCRIPTION = "#tsf-input-description";
        const TSF_INPUT_FILTER_NOTES = "#tsf-input-notes";
        const TSF_BTN_FILTER_SUBMIT = "#tsf-btn-submit";

        function getTableSelectFilterData() {

            return {
                purchasing_channel_type: $(TSF_INPUT_FILTER_PURCHASING_CHANNEL_TYPE).val(),
                product_type: $(TSF_INPUT_FILTER_PRODUCT_TYPE).val(),
                product_code: $(TSF_INPUT_FILTER_PRODUCT_CODE).val(),
                protocol_number: $(TSF_INPUT_FILTER_PROTOCOL_NUMBER).val(),
                purchasing_channel_id: $(TSF_INPUT_FILTER_PURCHASING_CHANNEL_ID).val(),
                sales_channel_id: $(TSF_INPUT_FILTER_SALES_CHANNEL_ID).val(),
                order_external: $(TSF_INPUT_FILTER_ORDER_EXTERNAL).val(),
                description: $(TSF_INPUT_FILTER_DESCRIPTION).val(),
                notes: $(TSF_INPUT_FILTER_NOTES).val(),
            }
        }

        function selectableProductLoaded(selectable_products) {
            $(TABLE_SELECT_BODY).html(selectable_products);
        }

        function loadSelectableProducts(transport_document_id) {

            const params = getTableSelectFilterData();
            params['wants_html'] = true;

            httpRequest.get(`admin/content/api/transport-documents/${transport_document_id}/get-selectable-products`, {
                params: params,
            })
                .then(response => selectableProductLoaded(response.data.data))
                .catch(error => {
                })
        }

        $(TSF_BTN_FILTER_SUBMIT).click(function (e) {
            e.preventDefault();
            loadSelectableProducts(_transport_document.id);
        });

        function associatedProductsLoaded(associated_products) {
            $(TABLE_DETAILS_BODY).html(associated_products);

            $(TABLE_DETAILS_BODY).sortable({});
        }

        function loadAssociatedProducts(transport_document_id) {

            const params = {
                wants_html: true,
            };

            httpRequest.get(`admin/content/api/transport-documents/${transport_document_id}/get-associated-products`, {
                params: params,
            })
                .then(response => associatedProductsLoaded(response.data.data))
                .catch(error => {
                });
        }

        function productAssociated(transport_document_item) {
            loadSelectableProducts(transport_document_item.transport_document_id);
            loadAssociatedProducts(transport_document_item.transport_document_id);
        }

        function associateProduct(transport_document_id, product_id, price) {

            const data = {
                product_id: product_id,
                price: price,
            };

            httpRequest.post(`admin/content/api/transport-documents/${transport_document_id}/associate-product`, data)
                .then(response => productAssociated(response.data.data))
                .catch(error => {
                });
        }

        $(TABLE_SELECT_BODY).on('click', BTN_ASSOCIATE, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input_price = $(TABLE_SELECT_BODY).find(`${INPUT_PRICE}[data-product-id=${product_id}]`);

            const price = input_price.val();

            associateProduct(_transport_document.id, product_id, price);
        });

        function setTransportDocumentItemDiscount(transport_document_id, transport_document_item_id, discount) {

            const data = {
                transport_document_item_id: transport_document_item_id,
                discount: !Utils.isEmpty(discount) ? discount : 0,
            };

            httpRequest.put(`admin/content/api/transport-documents/${transport_document_id}/set-transport-document-item-discount`, data)
                .then(response => loadAssociatedProducts(transport_document_id))
                .catch(error => {
                    alert("Non è stato possibile salvare lo sconto");

                });
        }

        $(TABLE_DETAILS_BODY).on('change', INPUT_DISCOUNT, function (e) {
            const transport_document_item_id = $(this).data(DATA_TRANSPORT_DOCUMENT_ITEM_ID);
            const discount = $(this).val();
            setTransportDocumentItemDiscount(_transport_document.id, transport_document_item_id, discount);
        });

        $(TABLE_DETAILS_BODY).on('keyup', INPUT_DISCOUNT, underscore.debounce(function (e) {
            const transport_document_item_id = $(this).data(DATA_TRANSPORT_DOCUMENT_ITEM_ID);
            const discount = $(this).val();
            setTransportDocumentItemDiscount(_transport_document.id, transport_document_item_id, discount);
        }, DEBOUNCE_MILLIS));


        function setTransportDocumentItemAmount(transport_document_id, transport_document_item_id, amount) {

            const data = {
                transport_document_item_id: transport_document_item_id,
                amount: !Utils.isEmpty(amount) ? amount : 0,
            };

            httpRequest.put(`admin/content/api/transport-documents/${transport_document_id}/set-transport-document-item-amount`, data)
                .then(response => loadAssociatedProducts(transport_document_id))
                .catch(error => {
                    alert("Non è stato possibile salvare l'importo");
                });
        }

        $(TABLE_DETAILS_BODY).on('change', INPUT_AMOUNT, function (e) {
            const transport_document_item_id = $(this).data(DATA_TRANSPORT_DOCUMENT_ITEM_ID);
            const amount = $(this).val();
            setTransportDocumentItemAmount(_transport_document.id, transport_document_item_id, amount);
        });

        $(TABLE_DETAILS_BODY).on('keyup', INPUT_AMOUNT, underscore.debounce(function (e) {
            const transport_document_item_id = $(this).data(DATA_TRANSPORT_DOCUMENT_ITEM_ID);
            const amount = $(this).val();
            setTransportDocumentItemAmount(_transport_document.id, transport_document_item_id, amount);
        }, DEBOUNCE_MILLIS));

        function transportDocumentItemDeleted() {
            loadAssociatedProducts(_transport_document.id);
            loadSelectableProducts(_transport_document.id);
        }

        function deleteTransportDocumentItem(transport_document_id, transport_document_item_id) {

            httpRequest.delete(`admin/content/api/transport-documents/${transport_document_id}/${transport_document_item_id}/destroy-transport-document-item`)
                .then(response => transportDocumentItemDeleted())
                .catch(error => {
                });
        }

        $(TABLE_DETAILS_BODY).on('click', BTN_DELETE_TRANSPORT_DOCUMENT_ITEM, function (e) {
            e.preventDefault();

            const transport_document_item_id = $(this).data(DATA_TRANSPORT_DOCUMENT_ITEM_ID);

            if (confirm('Vuoi veramente eliminare l\'elemento selezionato?')) {
                deleteTransportDocumentItem(_transport_document.id, transport_document_item_id);
            }

        });

        function getTableOrder(e) {

            const order = [];

            const children = $(e.target).children();

            for (const child of children) {
                const transport_document_item_id = $(child).data(DATA_TRANSPORT_DOCUMENT_ITEM_ID);

                if (!Utils.isEmpty(transport_document_item_id)) {
                    order.push(transport_document_item_id);
                }
            }

            return order;
        }

        function sortTransportDocumentItems(e, ui) {

            const order = getTableOrder(e);

            const target = $(e.target);

            target.sortable('disable');

            const data = {
                transport_document_items: order,
            };

            httpRequest.post(`admin/content/api/transport-documents/${_transport_document.id}/sort-transport-document-items`, data)
                .then(response => associatedProductsLoaded(response.data.data)).catch(error => {
                target.sortable('cancel');
            }).finally(function () {
                target.sortable('enable');
            });
        }

        function fixWidthHelper(e, ui) {

            ui.children().each(function () {
                $(this).width($(this).width());
            });

            return ui;
        }

        $(TABLE_DETAILS_BODY).sortable({
            helper: fixWidthHelper,
            stop: sortTransportDocumentItems,
            handle: ".sort-handle",
        });

        function invoiceGenerated() {
            loadAssociatedProducts(_transport_document.id);
            loadInvoices(_transport_document.id);
        }

        function generateInvoice(transport_document_id, transport_document_items) {
            const data = {
                transport_document_items: transport_document_items,
            };

            httpRequest.post(`admin/content/api/transport-documents/${transport_document_id}/generate-invoice`, data)
                .then(response => invoiceGenerated())
                .catch(error => {
                });
        }

        $(BTN_GENERATE_INVOICE).click(function (e) {
            e.preventDefault();

            const transport_document_items = [];

            $(`${TABLE_DETAILS_BODY} .input-invoice-exclude:checked`).each(function (index, item) {
                transport_document_items.push($(item).val());
            });

            generateInvoice(_transport_document.id, transport_document_items);

        });

        const TABLE_INVOICES = "#table-invoices";
        const TABLE_INVOICES_BODY = "#table-invoices tbody";
        const BTN_DELETE_INVOICE = ".btn-delete-invoice";


        function invoicesLoaded(invoices) {
            $(TABLE_INVOICES_BODY).html(invoices);
        }

        function loadInvoices(transport_document_id) {

            const params = {
                wants_html: true,
            };

            httpRequest.get(`admin/content/api/transport-documents/${transport_document_id}/get-invoices`, {
                params: params,
            })
                .then(response => invoicesLoaded(response.data.data))
                .catch(error => {
                })
        }

        function invoiceDeleted() {
            loadAssociatedProducts(_transport_document.id);
            loadInvoices(_transport_document.id);

        }

        function deleteInvoice(transport_document_id, invoice_id) {
            httpRequest.delete(`admin/content/api/transport-documents/${transport_document_id}/${invoice_id}/destroy-invoice`)
                .then(response => invoiceDeleted())
                .catch(error => {
                })
        }

        $(TABLE_INVOICES).on('click', BTN_DELETE_INVOICE, function (e) {
            e.preventDefault();

            if (confirm($(this).data('confirm-message'))) {
                const invoice_id = $(this).data(DATA_INVOICE_ID);
                deleteInvoice(_transport_document.id, invoice_id);
            }
        });

        const INPUT_TRANSPORT_DOCUMENT_DESCRIPTION = "#input-transport-document-description";
        const TRANSPORT_DOCUMENT_DESCRIPTION_STATUS = "#transport-document-description-status";
        const STYLE_SUCCESS = "bg-success text-white mt-1";
        const STYLE_ERROR = "bg-danger text-white mt-1";

        let description_status_timeout = null;

        function saveDescription(transport_document_id, description) {

            const data = {
                description: description,
            };

            if (description_status_timeout != null) {
                clearTimeout(description_status_timeout);
                description_status_timeout = null;
            }

            httpRequest.post(`admin/content/api/transport-documents/${transport_document_id}/save-description`, data)
                .then(response => {
                    $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).text('Descrizione salvata correttamente.');
                    $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).removeClass('d-none');
                    $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).addClass(STYLE_SUCCESS);
                    description_status_timeout = setTimeout(function () {
                        $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).removeClass();
                        $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).addClass('d-none');
                    }, 2000);
                })
                .catch(error => {
                    $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).text('Non è stato possibile salvare la descrizione.');
                    $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).removeClass('d-none');
                    $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).addClass(STYLE_ERROR);
                    description_status_timeout = setTimeout(function () {
                        $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).removeClass();
                        $(TRANSPORT_DOCUMENT_DESCRIPTION_STATUS).addClass('d-none');
                    }, 2000);
                });
        }


        $(TABLE_DETAILS_BODY).on('keyup', INPUT_TRANSPORT_DOCUMENT_DESCRIPTION, underscore.debounce(function (e) {
            e.preventDefault();
            const description = $(this).val();
            saveDescription(TRANSPORT_DOCUMENT_ID, description);
        }, 500));

        $(TABLE_DETAILS_BODY).on('change', INPUT_TRANSPORT_DOCUMENT_DESCRIPTION, function (e) {
            e.preventDefault();
            const description = $(this).val();
            saveDescription(TRANSPORT_DOCUMENT_ID, description);
        })

    },

    finalize() {

    },
}
